<template>
  <div class="app-date">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`input-group-${i}`"
        @click="removeError(i)"
        class="input-group">

        <el-date-picker
          v-model="valueLocal[i]"
          v-bind="widgetOptions"
          :class="{ 'child-has-error': error[i] }"
          :key="`date-input-${i}`"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          placeholder="Выберите дату..."/>

        <div v-if="error[i]" class="ait_message ait_message--error">{{ error[i] }}</div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
      errorBase: '',
    };
  },

};
</script>

<style lang="scss" scoped>
.app-date {
  .el-date-editor {
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppDate.vue